export class LinkedInUserCancelledAuthorize extends Error {
	constructor() {
		super('User refused to authorize the permissions to your application');
		this.name = 'LinkedInUserCancelledAuthorize';
	}
}
